/* eslint-disable ember/no-computed-properties-in-native-classes */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';

export default class BoardMainRollController extends Controller {
  @action
  setInclMain(value) {
    this.inclMain = value;
  }

  @action
  setInclSupp(value) {
    this.inclSupp = value;
  }

  queryParams = ['isSupplementaryRoll', 'isMainRoll'];
  @tracked isMainRoll = false;
  @tracked isSupplementaryRoll = false;
  @tracked inclSupp = true;
  @tracked inclMain = true;

  @computed('isMainRoll', 'isSupplementaryRoll')
  get isAllLabelData() {
    return !(this.isMainRoll || this.isSupplementaryRoll);
  }

  get listMainVoters() {
    return this.inclMain && (this.isAllLabelData || this.isMainRoll);
  }

  get listSupplementaryVoters() {
    return this.inclSupp && (this.isAllLabelData || this.isSupplementaryRoll);
  }

  get title() {
    if (this.isMainRoll || this.isSupplementaryRoll) {
      return this.isSupplementaryRoll
        ? 'Board Supplementary Roll'
        : 'Board Main Roll';
    }
    return 'All Voters Label Data';
  }
}
